/* Howdy Brewer Header v2 — self-contained, no external deps */
(function(){
  'use strict';
  var ROOT_SEL='.hb-header-v2';
  var DRAWER_SEL='#hb-header-v2-drawer';
  var TOGGLE_SEL='#hb-header-v2-menu-toggle, .hb-header-v2-m-menu-btn, [data-hb-drawer-toggle]';
  var CLOSE_SEL='[data-hb-drawer-close]';
  var ACCORDION_SEL='[data-hb-accordion-toggle]';

  function ready(fn){ if(document.readyState!=='loading') return fn(); document.addEventListener('DOMContentLoaded',fn); }
  function qs(s,c){ return (c||document).querySelector(s); }
  function qsa(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }

  function bindDrawer(){
    var drawer = qs(DRAWER_SEL);
    if(!drawer) return;
    var openers = qsa(TOGGLE_SEL);
    var lastFocused = null;
    function openDrawer(e){
      if(e) e.preventDefault();
      lastFocused = document.activeElement;
      drawer.setAttribute('aria-hidden','false');
      document.body.classList.add('hb-drawer-open');
      openers.forEach(function(b){ b.setAttribute('aria-expanded','true'); });
      var first = drawer.querySelector('input, button, a, [tabindex]:not([tabindex="-1"])');
      if(first) setTimeout(function(){ first.focus(); },80);
    }
    function closeDrawer(){
      drawer.setAttribute('aria-hidden','true');
      document.body.classList.remove('hb-drawer-open');
      openers.forEach(function(b){ b.setAttribute('aria-expanded','false'); });
      if(lastFocused && lastFocused.focus) lastFocused.focus();
    }
    openers.forEach(function(btn){
      btn.addEventListener('click', function(e){
        var isOpen = drawer.getAttribute('aria-hidden')==='false';
        if(isOpen) closeDrawer(); else openDrawer(e);
      });
    });
    drawer.addEventListener('click', function(e){ if(e.target===drawer) closeDrawer(); });
    qsa(CLOSE_SEL, drawer).forEach(function(el){
      el.addEventListener('click', function(e){ e.preventDefault(); closeDrawer(); });
    });
    document.addEventListener('keydown', function(e){
      if(e.key==='Escape' && drawer.getAttribute('aria-hidden')==='false') closeDrawer();
    });
    window.HbHeaderV2 = window.HbHeaderV2 || {};
    window.HbHeaderV2.openDrawer = openDrawer;
    window.HbHeaderV2.closeDrawer = closeDrawer;
  }

  function bindAccordions(){
    qsa(ACCORDION_SEL).forEach(function(row){
      row.addEventListener('click', function(e){
        var targetId = row.getAttribute('data-hb-accordion-target');
        if(!targetId) return;
        var panel = document.getElementById(targetId);
        if(!panel) return;
        e.preventDefault();
        var isOpen = panel.classList.contains('is-open');
        if(isOpen){ panel.classList.remove('is-open'); row.classList.remove('is-expanded'); row.setAttribute('aria-expanded','false'); }
        else{ panel.classList.add('is-open'); row.classList.add('is-expanded'); row.setAttribute('aria-expanded','true'); }
      });
    });
  }

  function updateHours(){
    var els = qsa('.hb-header-v2-hours');
    if(!els.length) return;
    var cfg = qs(ROOT_SEL);
    if(!cfg) return;
    var startH = parseFloat(cfg.getAttribute('data-hours-start')||'8.5');
    var endH = parseFloat(cfg.getAttribute('data-hours-end')||'17');
    var tz = cfg.getAttribute('data-hours-tz')||'America/Chicago';
    var openText = cfg.getAttribute('data-hours-open-text')||'Sales open';
    var closedText = cfg.getAttribute('data-hours-closed-text')||'After hours';
    var open = false;
    try{
      var now = new Date();
      var localStr = now.toLocaleString('en-US',{ timeZone: tz, hour12:false });
      var local = new Date(localStr);
      var day = local.getDay();
      var hf = local.getHours() + local.getMinutes()/60;
      if(day>=1 && day<=5 && hf>=startH && hf<endH){ open = true; }
    }catch(e){ open=false; }
    els.forEach(function(el){
      el.classList.toggle('is-open', open);
      var label = el.querySelector('.hb-header-v2-hours-text');
      if(label) label.textContent = open ? openText : closedText;
    });
    /* Body class drives CSS rules that hide the phone link after-hours on mobile. */
    document.body.classList.toggle('hb-after-hours', !open);
  }

  function bindZip(){
    var chips = qsa('[data-hb-zip]');
    if(!chips.length) return;
    var saved = null;
    try{ saved = window.localStorage.getItem('hb_ship_zip'); }catch(e){}
    function paintZip(z){
      chips.forEach(function(chip){
        var label = chip.querySelector('[data-hb-zip-value]');
        if(label && z) label.textContent = z;
      });
    }
    if(saved) paintZip(saved);
    chips.forEach(function(chip){
      chip.addEventListener('click', function(e){
        e.preventDefault();
        var current = (chip.querySelector('[data-hb-zip-value]')||{}).textContent||'';
        var next = window.prompt('Ship to ZIP code:', current.trim());
        if(!next) return;
        next = next.trim().replace(/[^0-9]/g,'').slice(0,5);
        if(next.length!==5) return;
        try{ window.localStorage.setItem('hb_ship_zip', next); }catch(e){}
        paintZip(next);
        document.dispatchEvent(new CustomEvent('hb:zip-change', { detail:{ zip: next } }));
      });
    });
  }

  function bindPredictive(){
    var inputs = qsa('.hb-header-v2-search-input');
    inputs.forEach(function(input){
      var wrap = input.closest('.hb-header-v2-search');
      if(!wrap) return;
      var pred = wrap.querySelector('.hb-header-v2-predictive');
      if(!pred) return;
      function show(){
        if(!input.value || input.value.length < 2) pred.setAttribute('aria-hidden','false');
      }
      function hide(){
        setTimeout(function(){ if(document.activeElement!==input) pred.setAttribute('aria-hidden','true'); },150);
      }
      function onInput(){
        if(input.value && input.value.length >= 2) pred.setAttribute('aria-hidden','true'); else show();
      }
      input.addEventListener('focus', show);
      input.addEventListener('blur', hide);
      input.addEventListener('input', onInput);
      qsa('.hb-header-v2-predictive-chip', pred).forEach(function(chip){
        chip.addEventListener('click', function(e){
          var q = (chip.getAttribute('data-q') || chip.textContent || '').trim();
          if(!q) return;
          e.preventDefault();
          input.value = q;
          var form = input.closest('form');
          if(form) form.submit();
        });
      });
    });
  }

  ready(function(){
    bindDrawer();
    bindAccordions();
    bindZip();
    bindPredictive();
    updateHours();
    setInterval(updateHours, 300000);
  });
})();
